
import { CommonSearchParam, ApiBind } from './common-search-param.model';

export class TesterGroupSearchParam extends CommonSearchParam {

  constructor(mediaType?: number) {
    super();
    this.mediaType = mediaType;
  }

  @ApiBind({ column: 'type' })
  mediaType: number;
}
